import { render, staticRenderFns } from "./beans-consume.vue?vue&type=template&id=0066c88c&scoped=true"
import script from "./beans-consume.vue?vue&type=script&lang=js"
export * from "./beans-consume.vue?vue&type=script&lang=js"
import style0 from "./beans-consume.vue?vue&type=style&index=0&id=0066c88c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0066c88c",
  null
  
)

export default component.exports